import React from 'react';

const RedirectingPage = React.memo(()=> {
	return <div className="min-h-full bg-white">
		<div className="flex min-h-full h-dvh flex-1 items-center px-8">
			<div className="mx-auto">
				<div className="flex flex-col items-center justify-center">
					<div
						className="border-gray-300 h-14 w-14 sm:h-20 sm:w-20 animate-spin rounded-full border-8 border-t-blue-600"></div>
					<div className="mt-2 text-sm leading-5 text-gray-500">Redirecting...</div>
					<div className="mt-6">
						<img
							className="h-6 w-auto"
							src="/assets/img/brand/rp-logo.svg"
							alt="RoomPulse"
						/>
					</div>
				</div>

			</div>
		</div>
	</div>
})

export default RedirectingPage;